(function(app) {

    app.filter("toPhoneNumber",
    [
        function() {
            return function(text) {
                if (!!text)
                    return text.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                return "";
            };
        }
    ]);

})(window.app); //jshint ignore:line